import axios from 'axios';
 
const url  = axios.create({
    baseURL: 'https://outsidecounseldev.sanantonio.gov/api/v1',
});
 
 
export const getGeneralTypes = async (endpoint) => {
 
 
    return await url
        .get(endpoint, {
 
            headers: {
                'Content-Type': 'application/json'
            }
 
        })
 
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error;
        });
 
}; 
 
export const postData = async (endpoint, data) => {
 
    return await url
        .post(endpoint, data
        )
 
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error;
        });
 
}
 
 
export const postDataResponse = async (endpoint, data) => {
 
    return await url
        .post(endpoint, data
        )
 
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        });
 
}
export const postUploadDocument = async (endpoint, formData) => {
    return await url
    .post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
    })
    .then((response) => {
        return response;
    })
    .catch((error) => {
        return error;
    });
}
 